<div class="modal fade" id="uploadModal" tabindex="-1" aria-labelledby="uploadModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered nec-upload-dialog ms-auto me-3">

    <div style="height: 95vh;" class="modal-content-nec modal-content rounded-5 shadow-lg border-0">

        <div class="modal-content-container">
          <div class="modal-content-header d-flex justify-content-between align-items-center">
            <h4>Upload</h4>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-content-body">
            <div class="template-file-container">
              <div class="template-file">
                <h5>Template Excel File</h5>
                <p>Download the sample file here to populate the customers data.</p>
                <div class="download-section d-flex align-items-center justify-content-between">
                  <div class="image">
                    <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_20341_230001)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.2509 0H26.8752L38.9036 12.0284V35.131C38.9036 37.9387 36.6087 40.2335 33.8011 40.2335H13.2509C10.4433 40.2335 8.14844 37.9387 8.14844 35.131V5.10251C8.14844 2.2948 10.4432 0 13.2509 0Z" fill="#00733B"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M26.875 0L38.9034 12.0284H28.1719C27.4567 12.0284 26.875 11.4467 26.875 10.7315V0Z" fill="#005C2F"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.45189 17.1328H30.1626C30.7788 17.1328 31.2824 17.6364 31.2824 18.2527V28.4186C31.2824 29.0348 30.7789 29.5407 30.1626 29.5407H2.45189C1.83566 29.5407 1.33203 29.0348 1.33203 28.4186V18.2527C1.33203 17.6364 1.83558 17.1328 2.45189 17.1328Z" fill="#005C2F"/>
                        <path d="M8.11957 21.9431V24.7208C8.11957 25.5151 8.76582 26.1613 9.5602 26.1613C10.3545 26.1613 11.0007 25.5151 11.0007 24.7208C11.0007 24.362 11.2916 24.0711 11.6503 24.0711C12.0091 24.0711 12.2999 24.362 12.2999 24.7208C12.2999 26.2315 11.0708 27.4605 9.56012 27.4605C8.0494 27.4605 6.82031 26.2314 6.82031 24.7208V21.9431C6.82031 20.4324 8.0494 19.2034 9.56012 19.2034C11.0708 19.2034 12.2999 20.4324 12.2999 21.9431C12.2999 22.3019 12.009 22.5927 11.6503 22.5927C11.2915 22.5927 11.0007 22.3019 11.0007 21.9431C11.0007 21.1488 10.3545 20.5025 9.5602 20.5025C8.76582 20.5025 8.11957 21.1488 8.11957 21.9431ZM15.8102 20.5025H16.8449C17.2627 20.5025 17.6026 20.8424 17.6026 21.2602C17.6026 21.619 17.8934 21.9098 18.2521 21.9098C18.6109 21.9098 18.9017 21.6189 18.9017 21.2602C18.9017 20.1261 17.979 19.2034 16.8448 19.2034H15.8101C14.4921 19.2034 13.4198 20.2747 13.4198 21.5913C13.4198 22.7567 14.0186 23.3252 14.5209 23.5969C15.1582 23.9416 15.9621 23.9815 16.5113 23.9815C17.1129 23.9815 17.6024 24.4699 17.6024 25.0702C17.6024 25.6718 17.1129 26.1613 16.5113 26.1613H15.4766C15.0588 26.1613 14.7189 25.8215 14.7189 25.4036C14.7189 25.0448 14.4281 24.754 14.0693 24.754C13.7105 24.754 13.4198 25.0448 13.4198 25.4036C13.4198 26.5378 14.3425 27.4605 15.4767 27.4605H16.5114C17.8294 27.4605 18.9017 26.3882 18.9017 25.0702C18.9017 23.7534 17.8294 22.6823 16.5114 22.6823C14.8539 22.6823 14.7191 22.1881 14.7191 21.5912C14.7191 20.991 15.2085 20.5025 15.8102 20.5025ZM25.3461 19.2364C25.0056 19.1233 24.6379 19.3077 24.5248 19.6481L22.8304 24.75L21.1359 19.6481C21.0228 19.3077 20.6553 19.1234 20.3147 19.2364C19.9742 19.3495 19.7898 19.7172 19.9029 20.0577L22.2139 27.0157C22.3021 27.2813 22.5504 27.4606 22.8304 27.4606C23.1103 27.4606 23.3587 27.2813 23.4468 27.0157L25.7577 20.0577C25.8708 19.7172 25.6865 19.3495 25.3461 19.2364Z" fill="white"/>
                      </g>
                    <defs>
                      <clipPath id="clip0_20341_230001">
                        <rect width="40.2335" height="40.2335" fill="white"/>
                      </clipPath>
                    </defs>
                    </svg>
                    <span>example.xlsx</span>
                  </div>
                  <button (click)="downloadTemplate()">Download</button>
                </div>
              </div>
            </div>
            <div class="upload-section-container">
              <div class="upload-section">
                <input #fileInput id="excelUpload" type="file" accept=".xlsx,.xls" (change)="onFileSelected($event, fileInput)" />
                <label for="excelUpload" class="upload d-flex flex-column align-items-center justify-content-center gap-2">
                  <div class="upload-icon">
                    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M16.9596 17.4704C18.9421 16.9139 20.3971 15.0767 20.3971 12.8962C20.3971 10.2745 18.2938 8.14918 15.6992 8.14918C15.1869 8.14918 14.6937 8.23205 14.2321 8.38523C13.2278 6.01342 10.8973 4.35156 8.18255 4.35156C4.55013 4.35156 1.60547 7.32701 1.60547 10.9974C1.60547 13.519 2.99522 15.7125 5.04297 16.8386M13.293 14.8932L11.0013 12.6016L8.70964 14.8932M11.0013 18.3307V13.0599" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </div>
                  <span class="main-text">Choose a file or drag & drop it here.</span>
                  <span class="subtext">Excel Format only</span>
                  <button (click)="fileInput.click()">Browse File</button>
                </label>
              </div>
            </div>
            <div class="data-container">
              <div class="data">
                <div class="data-table-container">
                  <table>
                    <thead>
                      <tr>
                        <th>Upload ID & Date</th>
                        <th>Name</th>
                        <th>Email Address</th>
                        <th>Role</th>
                        <th>Number of Entries</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let upload of uploads">
                        <td class="id-date d-flex flex-column">
                          <span class="id">#{{upload.id}}</span>
                          <span class="date">{{upload.lastUpdateTime | date:'MMM dd, yyyy hh:mma'}}</span>
                        </td>
                        <td class="name">{{ upload.name | hasValue }}</td>
                        <td class="email">{{ upload.email | hasValue }}</td>
                        <td class="role">{{ upload.role | hasValue }}</td>
                        <td class="entries">
                          <div class="progress-text">
                            {{ upload.numberOfEntries - upload.numberOfErrors }}/{{ upload.numberOfEntries }}
                          </div>

                          <div class="progress-bar">
                            <div
                              class="progress-bar-fill"
                              [style.width.%]="((upload.numberOfEntries - upload.numberOfErrors)/upload.numberOfEntries) * 100">
                            </div>
                          </div>
                        </td>
                        <td class="status">
                          <div [style.backgroundColor]=" upload.uploadFileStatus == 'Completed' ? '#2C8D2C26' : '#DE872426'" class="d-flex align-items-center gap-2">
                              <svg  width="11" height="11" viewBox="0 0 11 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="5.5" cy="5.5" r="5.5" [attr.fill]="upload.uploadFileStatus == 'Completed' ? '#65DAAB' : '#E8B44A'"/>
                                <path d="M5.5 0C4.04131 -1.73947e-08 2.64236 0.579463 1.61091 1.61091C0.579463 2.64236 1.27523e-07 4.04131 0 5.5C-1.27523e-07 6.95869 0.579462 8.35764 1.61091 9.38909C2.64236 10.4205 4.04131 11 5.5 11L5.5 5.5V0Z" [attr.fill]="upload.uploadFileStatus == 'Completed' ? '#01B86F' : '#E48512'"/>
                              </svg>
                            <span>
                              {{ upload.uploadFileStatus }}
                            </span>
                          </div>
                        </td>
                        <td class="icon">
                          <div>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M3.43647 7.16337L6.15006 9.19769C6.76771 9.6607 7.65378 9.4528 8.00108 8.76344C8.16304 8.44191 8.45676 8.20667 8.80589 8.11883L10.3201 7.73791C11.3039 7.49041 12.0717 6.72137 12.3173 5.7371L13.0568 2.77495M3.43647 7.16337C2.8501 8.31607 2.51953 9.62073 2.51953 11.0026C2.51953 15.6855 6.31579 19.4818 10.9987 19.4818C15.6816 19.4818 19.4779 15.6855 19.4779 11.0026C19.4779 7.02949 16.7452 3.69461 13.0568 2.77495M3.43647 7.16337C4.8372 4.4098 7.69766 2.52344 10.9987 2.52344C11.7085 2.52344 12.3979 2.61065 13.0568 2.77495" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                              <path d="M12.9051 15.5843C13.4236 15.5843 13.8975 15.2915 14.1294 14.8277C14.4373 14.2121 14.2399 13.4635 13.6685 13.0795L12.5205 12.3081C12.157 12.0638 11.7351 11.9204 11.2979 11.8925L10.6919 11.8539C10.3692 11.8332 10.0531 11.9522 9.82404 12.1805C9.44262 12.5605 9.38294 13.1572 9.68168 13.6052L10.2932 14.5225C10.7355 15.1859 11.48 15.5843 12.2773 15.5843H12.9051Z" stroke="#171717" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="data-pagination-container d-flex align-items-center">
                  <lib-pagination-new
                    [showCustomDropdown]="false"
                    [totalItems]="count"
                    [pageSize]="pageSize"
                    [currentPage]="currentPage"
                    (pageChange)="pageChange($event)"
                  ></lib-pagination-new>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  <div class="upload-description-overlay" *ngIf="showDescriptionPopup" (click)="cancelUpload()" (mousedown)="$event.stopPropagation()">
    <div class="upload-description-popup" (click)="$event.stopPropagation()">
      <div class="upload-description-header d-flex justify-content-between align-items-center">
        <h5>Upload Description</h5>
        <button type="button" class="btn-close-popup" (click)="cancelUpload()" aria-label="Close">&times;</button>
      </div>
      <form ngNativeValidate (submit)="confirmUpload()">
        <div class="upload-description-body d-flex flex-column gap-3">
          <div class="form-item d-flex flex-column gap-1">
            <label for="uploadDescription">Description</label>
            <input id="uploadDescription" name="description" type="text" [(ngModel)]="description" required placeholder="Enter a description for this upload" />
          </div>
          <div class="form-item d-flex flex-column gap-1">
            <label for="uploadServiceOrder">Service Upload Order</label>
            <input id="uploadServiceOrder" name="serviceUploadOrder" type="text" [(ngModel)]="serviceUploadOrder" placeholder="Optional" />
          </div>
        </div>
        <div class="upload-description-footer d-flex justify-content-end gap-2">
          <button type="button" class="btn-cancel" (click)="cancelUpload()">Cancel</button>
          <button type="submit" class="btn-submit">Upload</button>
        </div>
      </form>
    </div>
  </div>
</div>
